import React from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { CfdiUnidadMedidaService } from '../../../services/CfdiUnidadMedidaService';
import { Validators } from '../../../components/CatalogForm/validators';

const formFields = [
  {
    name: 'cfdi_clave',
    label: 'Clave SAT',
    type: 'text',
    col: 6,
    placeholder: 'Ej. E48',
    validators: [
      Validators.required("La clave es obligatoria")
    ],
  },
  {
    name: 'cfdi_nombre',
    label: 'Nombre',
    type: 'text',
    col: 6,
    placeholder: 'Ej. Unidad de Servicio',
    validators: [
      Validators.required("El nombre es obligatorio")
    ],
  },
  {
    name: 'cfdi_descripcion',
    label: 'Descripción',
    type: 'text',
    col: 12,
    placeholder: 'Descripción detallada de la unidad',
    validators: [
      Validators.required("La descripción es obligatoria")
    ],
  },
];

export const CfdiUnidadMedidaForm = () => {
  const { id } = useParams();

  const handleLoadData = async (recordId) => {
    return await CfdiUnidadMedidaService.obtenerPorId(recordId);
  };

  const handleSubmit = async (values) => {
    return await CfdiUnidadMedidaService.guardar(values);
  };

  return (
    <CatalogForm
      title="Unidad de Medida CFDI"
      subtitle="Catálogo de claves y unidades de medida"
      fields={formFields}
      id={id}
      loadData={handleLoadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/CfdiMedidaUnidades"
    />
  );
};

export default CfdiUnidadMedidaForm;
